<template>
  <AppLayout>
    <div class="row col-12 layout-spacing">
      <div class="col-md-12 col-lg-10 d-flex align-items-stretch">
        <div class="mb-3 me-3 col-auto d-flex align-items-center">
          <Link :href="route('bhp.zestawy.asekuracyjne')" class="btn btn-outline-primary"><i class="bi bi-list"></i>&nbsp;Powrót
            do listy
          </Link>
        </div>
      </div>

      <div class="col-md-6 mb-4">
        <div class="card h-100 shadow-sm d-flex flex-column">
          <div class="card-header"><h4>Przypisanie zestawu</h4></div>
          <div class="card-body">
            <div class="row mb-2">
              <div class="mb-3">
                <label class="form-label">Rodzaj przypisania</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="assignUser" value="1" v-model="assignType">
                    <label class="form-check-label" for="assignUser">Pracownik</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="assignDept" value="2" v-model="assignType">
                    <label class="form-check-label" for="assignDept">Dział</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="assignReserve" value="3" v-model="assignType">
                    <label class="form-check-label" for="assignReserve">Rezerwa</label>
                  </div>
                </div>
                <div v-show="assignType === '1'" class="mb-3">
                  <label for="sel_user_id" class="form-label">Pracownik</label>
                  <select v-model="selectedUser" class="select2 form-select w-100" id="sel_user_id">
                    <option v-for="u in users" :key="u.id" :value="u.id">{{ u.name }}</option>
                  </select>
                </div>
                <div v-show="assignType === '2'" class="mb-3">
                  <label for="sel_dep_id" class="form-label">Dział</label>
                  <select v-model="selectedDepartment" class="select2 form-select w-100" id="sel_dep_id">
                    <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
                  </select>
                </div>

                <div class="mb-1">
                  <label class="form-label">Uwagi</label>
                  <textarea class="form-control" rows="3" v-model="uwagi"></textarea>
                </div>
              </div>
            </div>
            <div class="text-end mt-auto p-3">
              <button class="btn btn-primary me-2" @click="updateZestaw">Zapisz</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <div class="card h-100 shadow-sm d-flex flex-column">
          <div class="card-header"><h4>Elementy zestawu nr {{ zestaw.zestaw_id }}</h4></div>
          <div class="card-body">
            <div class="row mb-2" v-for="type in [1,2,3]" :key="type">
              <div class="col-md-12">
                <label class="form-label">{{ selectLabel(type) }}</label>
                <select v-model="selectedElements[type]" class="form-select">
                  <option v-for="el in getAvailableForType(type)" :key="el.id" :value="el.id">{{ el.nr_seryjny }} -
                    {{ formatDate(el.data_produkcji) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="text-end mt-auto p-3">
              <button class="btn btn-primary me-2" @click="saveZestaw(zestaw.zestaw_id)">Zapisz</button>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-6 mb-4">
        <div class="card h-100 shadow-sm">
          <div class="card-header"><h4>Przeglądy zestawu</h4></div>
          <div class="card-body">
            <div class="h-100">
              <button @click="addPrzeglad" class="btn btn-primary btn-sm mb-2">
                <i class="bi bi-plus-circle me-2"></i>Dodaj przegląd
              </button>
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead>
                  <tr>
                    <th class="bg-gray-100">#</th>
                    <th class="bg-gray-100">Data przeglądu</th>
                    <th class="bg-gray-100">Akcje</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="addingNew">
                    <td>Nowy</td>
                    <td><input v-model="newPrzeglad.data_przegladu" class="form-control" type="date"/></td>
                    <td class="text-end">
                      <button @click="saveNewPrzeglad" class="btn btn-sm btn-success me-1"><i
                          class="bi bi-save me-2"></i>Zapisz
                      </button>
                      <button @click="cancelNewPrzeglad" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2"></i>Anuluj
                      </button>
                    </td>
                  </tr>

                  <tr v-for="(przeglad, index) in przeglady" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === przeglad.id" v-model="przeglad.data_przegladu" type="date"
                             class="form-control"/>
                      <span v-else>{{ formatDate(przeglad.data_przegladu) }}</span>
                    </td>
                    <td class="text-end">
                      <button v-if="editingId === przeglad.id" @click="updatePrzeglad(przeglad)"
                              class="btn btn-sm btn-success me-2">Zapisz
                      </button>
                      <button v-else @click="editPrzeglad(przeglad.id)" class="btn btn-sm btn-outline-info me-2"><i
                          class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button @click="deletePrzeglad(przeglad.id)" class="btn btn-sm btn-danger"><i
                          class="bi bi-trash me-2"></i>Usuń
                      </button>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {Link} from "@inertiajs/vue3";
import {Tooltip} from 'bootstrap';

export default {

  props: {
    zestaw: Object,
    zestawy: Array,
    elementy: Array,
    users: Array,
    departments: Array,
    przeglady: Array
  },
  data() {
    return {
      selectedElements: {1: null, 2: null, 3: null},
      uwagi: '',
      selectedUser: '',
      selectedDepartment: '',
      assignType: '',
      editingId: null,
      addingNew: false,
      newPrzeglad: this.getEmptyForm()
    };
  },
  components: {AppLayout, Link},
  mounted() {
    if (this.zestaw) {
      this.selectedElements = {
        1: this.zestaw.szelki?.id || null,
        2: this.zestaw.lina?.id || null,
        3: this.zestaw.zatrzasnik?.id || null
      };
      this.uwagi = this.zestaw.who_tekst || '';
      this.assignType = this.zestaw.who ? String(this.zestaw.who) : '1';
      this.selectedUser = this.zestaw.who === 1 ? this.zestaw.who_id : null;
      this.selectedDepartment = this.zestaw.who === 2 ? this.zestaw.who_id : null;
    }

    // inicjalizacja Select2 tylko raz
    $('#sel_user_id').select2({width: '100%'}).val(this.selectedUser).trigger('change');
    $('#sel_user_id').on('select2:select', (e) => {
      this.selectedUser = parseInt(e.params.data.id);
    });

    $('#sel_dep_id').select2({width: '100%'}).val(this.selectedDepartment).trigger('change');
    $('#sel_dep_id').on('select2:select', (e) => {
      this.selectedDepartment = parseInt(e.params.data.id);
    });
  },

  methods: {
    getEmptyForm() {
      return {
        id: null,
        data_przegladu: ''
      };
    },
    addPrzeglad() {
      this.addingNew = true;
      this.newPrzeglad = this.getEmptyForm();
    },
    cancelNewPrzeglad() {
      this.addingNew = false;
      this.newPrzeglad = this.getEmptyForm();
    },
    editPrzeglad(id) {
      this.editingId = id;
    },


    selectLabel(type) {
      switch (type) {
        case 1:
          return 'Szelki';
        case 2:
          return 'Lina';
        case 3:
          return 'Zatrzaśnik';
        default:
          return '';
      }
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('pl-PL') : '';
    },
    getAvailableForType(type) {
      const usedIds = new Set();
      this.zestawy.forEach(z => {
        if (type === 1 && z.szelki?.id && z.szelki.id !== this.zestaw.szelki?.id) usedIds.add(z.szelki.id);
        if (type === 2 && z.lina?.id && z.lina.id !== this.zestaw.lina?.id) usedIds.add(z.lina.id);
        if (type === 3 && z.zatrzasnik?.id && z.zatrzasnik.id !== this.zestaw.zatrzasnik?.id) usedIds.add(z.zatrzasnik.id);
      });

      return this.elementy.filter(el => el.rodzaj == type && (!usedIds.has(el.id) || el.id === this.selectedElements[type]));
    },
    saveZestaw(id) {
      const payload = {
        szelki_id: this.selectedElements[1],
        lina_id: this.selectedElements[2],
        zatrzasnik_id: this.selectedElements[3],
      };


      this.$inertia.post(route('bhp.zestawy.asekuracyjne.update'), {id: id, ...payload});


    },
    updateZestaw() {
      const payload = {
        zestaw_id: this.zestaw.zestaw_id,
        type: this.assignType,
        user_id: this.selectedUser,
        department_id: this.selectedDepartment,
        who_tekst: this.uwagi,
      };
      this.$inertia.post(route('bhp.zestawy.asekuracyjne.przypisz'), payload);
    },

    updatePrzeglad(przeglad) {
      this.$inertia.put(route('bhp.zestawy.asekuracyjne.przeglad.update', przeglad.id), przeglad, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewPrzeglad() {

      const payload = {
        zestaw_id: this.zestaw.zestaw_id,
        data_przegladu: this.newPrzeglad.data_przegladu,
      };

      this.$inertia.post(route('bhp.zestawy.asekuracyjne.przeglad.add'), payload, {
        onSuccess: () => {
          this.addingNew = false;
          this.newPrzeglad = this.getEmptyForm();
        }
      });
    },
    deletePrzeglad(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie daty przeglądu',
        html: 'Czy na pewno chcesz usunąć wybrany przegląd?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.zestawy.asekuracyjne.przeglad.delete', id));
        }
      });
    }

  },

};
</script>
<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
table th, table td {
  min-width: 50px;
  height: 32px;
}
.tooltip {
  opacity: 1 !important;
}
</style>
